export default "__VITE_ASSET__DecJzWBa__"